module.exports = __webpack_public_path__ + "media/images/flags/32/Afghanistan-d696dfd1c44005334416612d49e9b9d2.png";